// index.ts
import { bbox } from "@turf/bbox";
import { bboxPolygon } from "@turf/bbox-polygon";
function envelope(geojson) {
  return bboxPolygon(bbox(geojson));
}
var turf_envelope_default = envelope;
export {
  turf_envelope_default as default,
  envelope
};
//# sourceMappingURL=index.js.map